import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";

const ResultRenderer = ({ value }) => {

    if (value === undefined || value === null) return null;

    return (
        <span style={{ color: value === 0 || value === "Cumple perfil" ? "var(--ownBlue)" : value > 0 || value === "Supera perfil" ? "var(--ownGreen)" : "var(--ownRed)", fontWeight: 500 }}>
            {getLocalizedString(value === 0 || value === "Cumple perfil" ? "profileMatches" : value > 0 || value === "Supera perfil" ? "surpassesProfile" : "lowGap")}
        </span>
    )

}

export default ResultRenderer;